import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/storage'
import 'firebase/firestore'

const config = {
    apiKey: "AIzaSyCY824VHZ5ah_OmD9px6JVGkWY1P9eZgaM",
    authDomain: "gold-pacific.firebaseapp.com",
    databaseURL: "https://gold-pacific.firebaseio.com",
    projectId: "gold-pacific",
    storageBucket: "gold-pacific.appspot.com",
    messagingSenderId: "433968603217",
    appId: "1:433968603217:web:0864ed5f4836affcc75870",
    measurementId: "G-KDRN0FX3VV"
};
const firebaseApp = firebase.initializeApp(config);
const auth = firebase.auth();
const analytics = firebase.analytics();
const db = firebase.firestore();
const fs = firebase.storage();
export  {firebaseApp,auth,analytics,fs,db}
